<template>
  <div class="address" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul v-if="address !=''">
      <li v-for="(item,i) in address">
        <div class="left">
          <p>
            <span>创建时间：{{item.createtime}}</span>
          </p>
          <div class="add">{{item.address}}</div>
        </div>
        <div class="right" @click="deletes(item.id)">删除</div>
      </li>
    </ul>

    <div class="none" v-else>
      <img src="~assets/images/none.png" />
      <p>空空如也~</p>
    </div>
    <button class="addAddress" @click="toPush(id,'addmalladdress')">添加围栏地址</button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        address:[],
        id:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      this.id = this.$route.query.id;
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
      this.beforeMount();
      this.getAddress();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getAddress:function(){
        var that = this;
        var mall_id = that.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/mallAddress',
          params:{
            mall_id:mall_id
          }
        }).then(function(response){
          var res = response.data.data;
          that.address = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      deletes:function(id){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/deletedz',
          params:{
            id:id
          }
        }).then(function(response){
          that.getAddress();
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      choose:function(id){
        var that = this;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/status',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          that.$router.go(-1)
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
        
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .address{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-top:15px;
  }
  .address ul{
    width:94%;
    margin: 0 auto;
  }
  .address li{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin-bottom:15px
  }
  .address li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .address li .left{
    float:left;
    width:76%;
    margin:4% 0 4% 4%;
    border-radius:5px;
    position:relative
  }
  .address li .left:after{
    content:'';
    height:50px;
    width:1px;
    background:#f1f1f1;
    position:absolute;
    right:0;
    top:4%;
  }
  .address li .left span{
    font-size:15px;
    margin-right:10px
  }
  .address li .left font{
    font-size:12px;
    background:rgba(255,0,0,.7);
    color:#fff;
    padding:3px 8px;
    border-radius:5px;
  }
  .address li .left .add{
    padding-top:10px;
    font-size:15px;
    letter-spacing:1px;
  }
  .address li .right{
    float:left;
    width:20%;
    margin-top:8%;
    color:#f00;
    text-align:center;
    font-weight:bold;
    font-size:15px;
  }
  .address .addAddress{
    position: fixed;
    bottom: 30px;
    left: 10%;
    width:80%;
    height:45px;
    border:none;
    background:#007aff;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }

  .address .none{
    text-align:center;
    padding-top:120px
  }
  .address .none img{
    display:block;
    margin:0px auto;
    width:100px;
  }
  .address .none p{
    color:#999;
    font-size:15px;
    padding-top:5px;
    letter-spacing:2px;
  }
</style>